// src/services/workOrderService.js
import { getData, saveData } from './storageService';

export class WorkOrderService {
  constructor() {
    this.workOrders = [];
    this.templates = [];
    this.loadData();
  }

  async loadData() {
    try {
      this.workOrders = await getData('work_orders') || [];
      this.templates = await getData('work_order_templates') || this.generateDefaultTemplates();
    } catch (error) {
      console.error('Error loading work orders:', error);
      this.workOrders = [];
      this.templates = this.generateDefaultTemplates();
    }
  }

  async saveData() {
    await saveData('work_orders', this.workOrders);
    await saveData('work_order_templates', this.templates);
  }

  async addPhotoToWorkOrder(workOrderId, photo) {
  const workOrder = this.workOrders.find(wo => wo.id === workOrderId);
  if (!workOrder) throw new Error('Work order not found');

  if (!workOrder.photos) workOrder.photos = [];
  workOrder.photos.push({
    ...photo,
    timestamp: new Date().toISOString()
  });

  await this.saveData();
  return workOrder;
}

// Оновлення статусу наряду
async updateWorkOrderStatus(workOrderId, status, updates = {}) {
  const workOrder = this.workOrders.find(wo => wo.id === workOrderId);
  if (!workOrder) throw new Error('Work order not found');

  workOrder.status = status;
  Object.assign(workOrder, updates);

  if (status === 'completed') {
    workOrder.completedAt = new Date().toISOString();
  }

  await this.saveData();
  return workOrder;
}

  generateDefaultTemplates() {
    return [
      {
        id: 'template_preventive',
        name: 'Preventive Maintenance',
        type: 'preventive',
        steps: [
          { step: 1, action: 'Visual Inspection', description: 'Check for visible damage or wear' },
          { step: 2, action: 'Lubrication', description: 'Apply lubricant to moving parts' },
          { step: 3, action: 'Calibration', description: 'Verify and adjust settings' },
          { step: 4, action: 'Testing', description: 'Run operational tests' }
        ],
        estimatedTime: 120,
        requiredParts: ['lubricant', 'cleaning_supplies']
      }
    ];
  }

  // Отримання нарядів для техніка
  getWorkOrdersForTechnician(technicianId, status = null) {
    let orders = this.workOrders.filter(wo => wo.assignedTo === technicianId);
    
    if (status) {
      orders = orders.filter(wo => wo.status === status);
    }

    return orders.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));
  }

  // Створення демо-даних для тестування
  generateDemoWorkOrders() {
    this.workOrders = [
      {
        id: 'wo_001',
        title: 'Repair Water Leak - Lavadora L-12',
        description: 'Fix water leak detected in technician report',
        machineId: 'L-12',
        machineName: 'Lavadora L-12',
        priority: 'high',
        type: 'repair',
        status: 'assigned',
        assignedTo: 'tech_001',
        createdBy: 'system',
        createdAt: new Date().toISOString(),
        dueDate: new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(),
        estimatedTime: 120,
        steps: [
          { step: 1, action: 'Diagnosis', description: 'Identify leak source' },
          { step: 2, action: 'Part Replacement', description: 'Replace faulty valve' },
          { step: 3, action: 'Testing', description: 'Verify no leaks' }
        ],
        requiredParts: ['valve_002'],
        actualTime: 0,
        completedAt: null,
        photos: [],
        notes: '',
        location: 'Main Facility'
      },
      {
        id: 'wo_002',
        title: 'Monthly Maintenance - Secadora S-05',
        description: 'Regular preventive maintenance',
        machineId: 'S-05',
        machineName: 'Secadora S-05',
        priority: 'medium',
        type: 'preventive',
        status: 'assigned',
        assignedTo: 'tech_001',
        createdBy: 'system',
        createdAt: new Date().toISOString(),
        dueDate: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000).toISOString(),
        estimatedTime: 90,
        steps: [
          { step: 1, action: 'Cleaning', description: 'Clean filters and vents' },
          { step: 2, action: 'Inspection', description: 'Check heating elements' },
          { step: 3, action: 'Testing', description: 'Run full cycle test' }
        ],
        requiredParts: ['filter_004'],
        actualTime: 0,
        completedAt: null,
        photos: [],
        notes: '',
        location: 'Main Facility'
      }
    ];
    
    return this.workOrders;
  }

  // Отримати запчастини, що потребують поповнення
  getPartsNeedingRestock() {
    // Тимчасово повертаємо пустий масив
    return [];
  }
}

// Експорт за замовчуванням для сумісності
export default WorkOrderService;